import React from 'react';
import { Row, Col, Table, Form, Button } from "reactstrap";

/**
 * 
 * @param {*} planes lista de planes 
 * @returns Array con planes formateado para la lista
 */
function obtenerValores(planes) {

  var auxPrincipal = [];

  planes[0].valoresCobertura.forEach(cobertura => {
    var auxSecundario = []

    planes.forEach(plan => {

      plan.valoresCobertura.forEach(valor => {

        if (cobertura.titulo == valor.titulo) {
          auxSecundario.push(valor)

        }

      });

    });
    auxPrincipal.push(auxSecundario)

  })


  return auxPrincipal;





}


const Planes = (props) => {

  return (
    <Row>
      <Col xs={7} sm={4} md={5} lg={5} xl={3}>
        <Table borderless size={'lg'}>
          <thead>
            <tr>
              <th>
                <div className="div-align-center" style={{ backgroundColor: "#a8a8aa", width: '200px' }}>
                  <h6 style={{ fontWeight: "large", color: "#001871", textAlign: "center" }} >COBERTURA</h6>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>

            {props.planes[0].valoresCobertura.map(valor => {
              return (
                <tr>
                  <th>
                    <div className="div-align-center" style={{ backgroundColor: "#d1d0ce", width: '200px', height: props.height }}>
                      <p style={{ textAlign: "center", }} >{valor.titulo}</p>
                    </div>
                  </th>

                </tr>
              )
            })}
            <tr>
              <th>
                <div className="div-align-center" style={{ backgroundColor: "#d1d0ce", width: '200px', height: props.height }}>
                  <p style={{ textAlign: "center", }} >{'PRIMA INCLUIDA IMPUESTOS:'}</p>
                </div>
              </th>
            </tr>



          </tbody>
        </Table>
      </Col>
      <Col xs={5} sm={8} md={7} lg={7} xl={9}>
       
          {props.planes && (
            <Table borderless responsive size={'lg'}>
              <thead>
                <tr>

                  {props.planes.map(plan => {

                    return (
                      <th  >
                        <div className="div-align-center" style={{ backgroundColor: "#001871", width: '120px' }}>
                          <p style={{ color: `#ffffff`, textAlign: "center", textTransform: "uppercase" }} >{'PLAN ' + plan.titulo}</p>
                        </div>

                      </th>
                    )

                  })}





                </tr>
              </thead>
              <tbody>

                {
                  obtenerValores(props.planes).map(cobertura => {
                    return (
                      <tr>
                        {cobertura.map(valor => {
                          return (
                            <td>
                              <div className="div-align-center" style={{ backgroundColor: "#F0F0EB", width: '120px', height: props.height }}>
                                <p style={{ textAlign: "center" }} >{'$' + parseFloat(valor.valor).toFixed(2)}</p>
                              </div>
                            </td>
                          )
                        })}



                      </tr>
                    )
                  })
                }
                <tr>
                  {props.planes.map(plan => {

                    return (
                      <td>
                        <div className="div-align-center" style={{ backgroundColor: "#F0F0EB", width: '120px', height: props.height }}>
                          <p style={{ textAlign: "center" }} >{'$'+parseFloat(plan.primaCobertura[6].valor).toFixed(2)}</p>
                        </div>
                      </td>
                    )









                  })}
                </tr>


                {props.planes.map(plan => {

                  return (
                    <th  >
                      <Button className="div-align-center btn btn-primary" onClick={() => {
                        props.onChangePlan(plan)
                      }}
                        style={{
                          margin: "auto",
                          backgroundColor: plan.codigoProducto == props.planSeleccionado ? '#AF006E' : '#001871',
                          borderColor: plan.codigoProducto == props.planSeleccionado ? '#AF006E' : '#001871',

                        }}>
                        {plan.codigoProducto == props.planSeleccionado ? 'SELECCIONADO' : 'SELECCIONAR'}
                      </Button>

                    </th>
                  )

                })}




              </tbody>
            </Table>
          )}
     


      </Col>
    </Row>
  );
};

export default Planes;
